import classNames from 'classnames'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import LoadingWrapper from 'components/loading/LoadingWrapper'
import { CREATIVE, KEYWORD } from 'features/report/common/DomainText'
import {
  fetchAdGroups,
  fetchCampaigns,
  setAdGroupId,
  setCampaignId,
  setCampaignType,
} from 'features/report/reportAddSlice'
import NoneAnchor from 'components/NoneAnchor'
import { CampaignTypeNames, CampaignTypes } from '../../Codes'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'

const adgroupSelectableDomains = [CREATIVE, KEYWORD]
const allAdGroup = {
  id: '',
  name: '전체',
}

const CampaignGroupFilter = () => {
  const dispatch = useDispatch()
  const {
    isFilterLoading,
    campaigns,
    groups,
    formValues: { domain, campaignId, adGroupId, campaignType },
  } = useSelector(state => state.report.reportAdd)
  const [visible, setVisible] = useState(false)
  const ref = useOutsideClick(() => setVisible(false))
  const filteredCampaigns = useMemo(
    () => campaigns.filter(campaign => campaign.campaignType === campaignType),
    [campaignType, campaigns]
  )
  const selectedCampaign = useMemo(() => {
    if (campaignId === undefined) return undefined
    return filteredCampaigns.find(({ id }) => id === campaignId)
  }, [campaignId, filteredCampaigns])
  const selectedAdGroup = useMemo(() => {
    if (adGroupId === allAdGroup.id) return allAdGroup
    if (adGroupId === undefined) return undefined
    return groups.find(({ id }) => id === adGroupId)
  }, [adGroupId, groups])

  useEffect(() => {
    dispatch(fetchCampaigns())
  }, [dispatch])

  useEffect(() => {
    if (campaignId) {
      dispatch(fetchAdGroups())
    }
  }, [dispatch, campaignId])

  const handleCampaignTypeChange = type => () => {
    dispatch(setCampaignType(type))
  }
  const handleCampaignChange = id => () => {
    dispatch(setCampaignId(id))
    if (!adgroupSelectableDomains.includes(domain)) {
      setVisible(false)
    }
  }
  const handleAdGroupChange = id => () => {
    dispatch(setAdGroupId(id))
    setVisible(false)
  }

  return (
    <div ref={ref} className="single_wrap">
      <div
        className={classNames('opt_select opt_group', {
          opt_open: visible,
        })}>
        <div className="screen_out">데이터종류 선택상자</div>
        <span className="screen_out">선택내용 : </span>
        <NoneAnchor
          className="link_selected"
          onClick={() => setVisible(prev => !prev)}>
          {adgroupSelectableDomains.includes(domain)
            ? selectedAdGroup
              ? selectedAdGroup.name
              : '광고그룹 선택'
            : selectedCampaign
            ? selectedCampaign.name
            : '캠페인 선택'}
        </NoneAnchor>
        <span className="ico_arr" />
        <div className="screen_out">선택옵션</div>
        <div className="optlist_data">
          <div className="inner_optlist">
            <ul className="list_data">
              <li>
                <strong className="tit_data">캠페인 유형</strong>
                <NoneAnchor
                  className={classNames('link_option', {
                    on: campaignType === undefined,
                  })}
                  onClick={handleCampaignTypeChange(undefined)}>
                  <span className="txt_limit">없음</span>
                </NoneAnchor>
                <NoneAnchor
                  className={classNames('link_option', {
                    on: campaignType === CampaignTypes.PREMIUM_LINK,
                  })}
                  onClick={handleCampaignTypeChange(
                    CampaignTypes.PREMIUM_LINK
                  )}>
                  <span className="txt_limit">
                    {CampaignTypeNames[CampaignTypes.PREMIUM_LINK]}
                  </span>
                </NoneAnchor>
                <NoneAnchor
                  className={classNames('link_option', {
                    on: campaignType === CampaignTypes.TALK_CHANNEL,
                  })}
                  onClick={handleCampaignTypeChange(
                    CampaignTypes.TALK_CHANNEL
                  )}>
                  <span className="txt_limit">
                    {CampaignTypeNames[CampaignTypes.TALK_CHANNEL]}
                  </span>
                </NoneAnchor>
              </li>
              {domain === KEYWORD &&
              campaignType === CampaignTypes.TALK_CHANNEL ? (
                <>
                  <li>
                    <strong className="tit_data">캠페인</strong>
                  </li>
                  <li>
                    <strong className="tit_data">광고그룹</strong>
                  </li>
                  <div className="nodata_info nodata_info2">
                    <p className="txt_empty">
                      톡채널검색의 키워드 상세보고서는 추후 제공 예정입니다.
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <li>
                    <strong className="tit_data">캠페인</strong>
                    {campaignType === undefined ? (
                      <div className="nodata_info">
                        <p className="txt_empty">
                          캠페인 유형을 먼저
                          <br />
                          선택해주세요.
                        </p>
                      </div>
                    ) : (
                      <>
                        <NoneAnchor
                          className={classNames('link_option', {
                            on: campaignId === undefined,
                          })}
                          onClick={handleCampaignChange(undefined)}>
                          <span className="txt_group">없음</span>
                        </NoneAnchor>
                        {filteredCampaigns.map(({ id, name, deletedDate }) => (
                          <NoneAnchor
                            key={id}
                            className={classNames('link_option', {
                              on: id === campaignId,
                            })}
                            onClick={handleCampaignChange(id)}>
                            {deletedDate && (
                              <span className="txt_sort">(삭제)</span>
                            )}
                            <span className="txt_group">{name}</span>
                          </NoneAnchor>
                        ))}
                      </>
                    )}
                  </li>
                  {adgroupSelectableDomains.includes(domain) && (
                    <li>
                      <LoadingWrapper isLoading={isFilterLoading}>
                        <strong className="tit_data">광고그룹</strong>
                        {campaignId && (
                          <>
                            <NoneAnchor
                              className={classNames('link_option', {
                                on: adGroupId === allAdGroup.id,
                              })}
                              onClick={handleAdGroupChange(allAdGroup.id)}>
                              {allAdGroup.name}
                            </NoneAnchor>
                            <NoneAnchor
                              className={classNames('link_option', {
                                on: adGroupId === undefined,
                              })}
                              onClick={handleAdGroupChange(undefined)}>
                              없음
                            </NoneAnchor>
                          </>
                        )}
                        {campaignId ? (
                          groups.map(({ id, name, deletedDate }) => (
                            <NoneAnchor
                              key={id}
                              className={classNames('link_option', {
                                on: id === adGroupId,
                              })}
                              onClick={handleAdGroupChange(id)}>
                              {deletedDate && (
                                <span className="txt_sort">(삭제)</span>
                              )}
                              <span className="txt_group">{name}</span>
                            </NoneAnchor>
                          ))
                        ) : (
                          <div className="nodata_info">
                            <p className="txt_empty">
                              캠페인을 먼저
                              <br />
                              선택해주세요.
                            </p>
                          </div>
                        )}
                      </LoadingWrapper>
                    </li>
                  )}
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CampaignGroupFilter
